import React, { useEffect, useRef, useState } from 'react';
import useIsInView from '../../../../Shared/hooks/useIsInView';
import Translation from '../../../../Shared/components/Translation';
const AffordabilityScale = ({ affordabilityScore, className }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const labelsRef = useRef(null);
    const isInView = useIsInView(labelsRef);
    // Show animation 500ms after the entire scale is scrolled into view
    useEffect(() => {
        if (!isInView || isLoaded) {
            return;
        }
        setTimeout(() => {
            setIsLoaded(true);
        }, 500);
    }, [isLoaded, isInView]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "zds-relative" },
            React.createElement("svg", { viewBox: "0 0 169 85" },
                React.createElement("g", { stroke: "#FFF", fill: "none", fillRule: "evenodd" },
                    React.createElement("path", { d: "M58.63 5l9.856 30.506c-10.31 3.401-19.137 10.066-25.257 18.772l-26.23-19.056C27.222 21.172 41.743 10.454 58.632 5z", fill: "#96BC33" }),
                    React.createElement("path", { d: "M152.337 35.27l-26.231 19.058c-6.076-8.7-14.849-15.378-25.106-18.82L110.856 5c16.836 5.495 31.304 16.226 41.481 30.27z", fill: "#FAA61E" }),
                    React.createElement("path", { d: "M167.958 82.31l.01 1.373h-33.01A49.77 49.77 0 00126 54.103L152.2 35c9.67 13.33 15.472 29.65 15.759 47.31z", fill: "#EF4024" }),
                    React.createElement("path", { d: "M16.808 35l26.198 19.102A49.77 49.77 0 0034 82.736l.002.5h0l.007.5H1l.011-1.373C1.298 64.68 7.115 48.341 16.808 35z", fill: "#00A652" }),
                    React.createElement("path", { d: "M84.53 1c8.997 0 17.66 1.432 25.773 4.08l-9.855 30.507A49.945 49.945 0 0084.53 33c-5.475 0-10.745.88-15.675 2.506L58.999 5.001A82.941 82.941 0 0184.53 1z", fill: "#FFD528" }))),
            React.createElement("svg", { viewBox: "0 0 23 136", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
                    position: 'absolute',
                    bottom: '-4%',
                    left: 'calc(50% - 4%)',
                    opacity: isLoaded ? 1 : 0,
                    transform: `rotate(${isLoaded ? 38 * (affordabilityScore - 3) : -93}deg)`,
                    transformOrigin: '50% 92%',
                    transition: `transform 500ms cubic-bezier(0, 0, 0.16, 1), opacity 500ms ease`,
                    width: '8%',
                } },
                React.createElement("path", { d: "M9.20638 2.89608C9.29265 1.73361 10.261 0.834473 11.4266 0.834473V0.834473C12.5923 0.834473 13.5606 1.7336 13.6469 2.89608L22.6008 123.548C23.083 130.045 17.9416 135.582 11.4266 135.582V135.582C4.91166 135.582 -0.229705 130.045 0.252464 123.548L9.20638 2.89608Z", fill: "black" }))),
        React.createElement("div", { className: "zds-relative", ref: labelsRef },
            React.createElement("div", { className: "zds-absolute zds-text-center", style: { left: '-40%', width: '100%' } },
                React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.affordabilityLow" })),
            React.createElement("div", { className: "zds-absolute zds-text-center", style: { right: '-40%', width: '100%' } },
                React.createElement(Translation, { item: "tx_zigrealestate.details.housingCosts.affordabilityHigh" })))));
};
export default AffordabilityScale;
